import * as React from 'react';

interface Props {
    returnToLobby: React.EventHandler<React.MouseEvent | React.KeyboardEvent>;
}

export const BackToLobbyButton = (props: Props) => {
    const { returnToLobby } = props;
    return (
        <button type="button" className="btn-back" onClick={returnToLobby}>
            <img id="btn-back" src="/images/header/btn_back.svg" alt="Return to lobby" />
        </button>
    );
};
